export class MapListFilter {
  value: string | number
  type: MapListFilterType
  isActive: boolean = false

  static fromJson(json: {
    value: string | number
    type: MapListFilterType
    isActive: boolean
  }): MapListFilter {
    const filter = new MapListFilter(json.value, json.type)
    filter.isActive = json.isActive

    return filter
  }

  constructor(value: string | number, type: MapListFilterType) {
    this.value = value
    this.type = type
  }

  get title(): string {
    switch (this.type) {
      case MapListFilterType.distance:
        return 'mapList.filter.distance.title'
      case MapListFilterType.searchKey:
        return 'mapList.filter.search.title'
      default:
        return undefined
    }
  }
  get valueTitle(): string {
    switch (this.type) {
      case MapListFilterType.distance:
        const value = this.realValue
        if (
          value === undefined ||
          value === null ||
          typeof value !== 'number' ||
          isNaN(value as number)
        ) {
          return `–`
        }
        return `${value}`
      case MapListFilterType.searchKey:
        if (this.value) {
          return `"${this.value}"`
        }
        return undefined
      default:
        return undefined
    }
  }

  get realValue(): number | string {
    switch (this.type) {
      case MapListFilterType.distance:
        const options = [1, 2, 5, 10, 25, 50, 75, 100, 200, 300, 500]
        const numberValue = this.value as number
        if (numberValue > options.length) {
          return options[options.length - 1]
        }
        return options[numberValue]
      default:
        break
    }
    return this.value
  }

  get showSecondaryLabel(): boolean {
    switch (this.type) {
      case MapListFilterType.distance:
        return false
      case MapListFilterType.searchKey:
        return false
      default:
        return false
    }
  }

  get hintText(): string {
    switch (this.type) {
      case MapListFilterType.distance:
        return 'mapList.filter.distance.hint'
      case MapListFilterType.searchKey:
        return undefined
      default:
        return undefined
    }
  }

  get showInterface(): boolean {
    switch (this.type) {
      case MapListFilterType.location:
        return false
      default:
        return true
    }
  }

  get sortKey(): number {
    switch (this.type) {
      case MapListFilterType.distance:
        return 0
      case MapListFilterType.location:
        return 10
      case MapListFilterType.searchKey:
        return 20
    }
  }
}

export enum MapListFilterType {
  distance = 'distance',
  searchKey = 'searchKey',
  location = 'location',
}

export function getInitialMapListFilters(): MapListFilter[] {
  return Object.keys(MapListFilterType)
    .map(
      (type) =>
        new MapListFilter(
          undefined,
          MapListFilterType[type as keyof typeof MapListFilterType]
        )
    )
    .sort((a, b) => a.sortKey - b.sortKey)
}
